export enum ContractPricingFrequency {
  BULK_SPOT_QUOTE = "BULK_SPOT_QUOTE",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  BIANNUALLY = "BIANNUALLY",
  ANNUALLY = "ANNUALLY",
}
